import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';

export function useToggleFolderFavouriteMutation() {
  const queryClient = useQueryClient();

  const { mutateAsync: toggleFavourite, isLoading } = useMutation(
    ({ id, isFavourite }: { id: string; isFavourite: boolean }) =>
      isFavourite
        ? API_HANDLERS.FOLDERS.REMOVE_FAVOURITE(id)
        : API_HANDLERS.FOLDERS.ADD_FAVOURITE(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['folders']);
      },
    },
  );

  return { toggleFavourite, isLoading };
}
